import React, { createContext, useState } from 'react';
const ApplicationContext = createContext();
const ApplicationContextProvider = ({ children }) => {
    const initialValue = [
        {
            "Nom": "N/D",
            "Date creation": "N/D",
            "Date validation": "N/D",
            "Access_id": "N/D",
            "Status": "N/D"
        }
    ];

    const initialPlan = [
        {
            "Nom": "N/D",
            "Nombre information": 0,
            "Nombre option": 0,
            "Date creation": "N/D",
            "Prix": "N/D",
            "Periodicite": "N/D",
            "Status": "N/D"
        }
    ];

    const initialSubscriptions = [
        {
            "Nom": "N/D",
            "Client": "N/D",
            "Nombre information": 0,
            "Nombre option": 0,
            "Date sousscription": "N/D",
            "Date expiration": "N/D",
            "Status": "N/D"
        }
    ];

    const initialOiptions = [
        {
            "Nom": "N/D",
            "Type de donnees": "N/D",
        }
    ];

    const initialListInfos = [
        {
            id: "N/D",
            value: "N/D",
            type:"N/D"
        }
    ];

    const initialSubscriptionPack={
        title:"N/D",
        periodicity:"N/D",
        price:0.0,
        devise:"N/D",
        options:[
            {
                id:"N/D",
                value:"N/D",
            }
        ],
        informations:[
            {
                id:"N/D",
                tag:"N/D",
                dataType:"N/D"
            }
        ],
    };

    const findLargestOptionsSize = (data) => {
        let maxSize = 0;

        data.forEach(item => {
            if (item.options.length > maxSize) {
                maxSize = item.options.length;
            }
        });

        return maxSize;
    };

    const [application, setApplication] = useState(initialValue);
    const [selectedInfos, setSelectedInfos] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [subscriptionPlan, setSubscriptionPlan] = useState(initialPlan);
    const [subscriptions, setSubscriptions] = useState(initialSubscriptions);
    const [options, setOptions] = useState(initialOiptions);
    const [subscriptionPack, setSubscriptionPack] = useState(initialSubscriptionPack);
    const [informations, setInformations] = useState(initialOiptions);
    const [cdfAccount, setCDFAccount] = useState(0.0);
    const [usdAccount, setUSDAccount] = useState(0.0);
    const [listInfo, setListInfo]=useState(initialListInfos);
    const [listOptions, setLisOptions]=useState(initialListInfos);
    const [solution, setSolution] = useState({});

    const updateAccount = (devise, amount) => {
        if(devise === "USD"){
            setUSDAccount(usdAccount+amount);
        }else if(devise === "CDF"){
            setCDFAccount(cdfAccount+amount);
        }
    };

    const updateApp=(appValue)=>{
        const newValue=[];
        newValue.push(appValue);
        setApplication(newValue);
    }

    const updateInfo=(infoValue)=>{
        setInformations(infoValue);
    }

    const updateOptions=(infoValue)=>{
        setOptions(infoValue);
    }

    const updateListInfo=(infoValue)=>{
        setListInfo(infoValue);
    }

    const updateListOptions=(infoValue)=>{
        setLisOptions(infoValue);
    }

    const updatePlans=(infoValue)=>{
        setSubscriptionPlan(infoValue);
    }

    return (
        <ApplicationContext.Provider value={{
            application,
            usdAccount,
            cdfAccount,
            subscriptionPlan,
            subscriptions,
            options,
            informations,
            listInfo,
            listOptions,
            subscriptionPack,
            selectedInfos,
            setSelectedInfos,
            selectedOptions,
            setSelectedOptions,
            updateListInfo,
            updateListOptions,
            updateAccount,
            updateApp,
            updateInfo,
            updateOptions,
            updatePlans,
            findLargestOptionsSize,
            solution,
            setSolution
        }}>
            {children}
        </ApplicationContext.Provider>
    );
};

export { ApplicationContext, ApplicationContextProvider };
